import React from "react";
import { useNavigate } from "react-router-dom";

const SERVICE_PRICING = [
  { icon: "🧹", category: "House Cleaning", typical: "$80-$200", per: "per visit", details: ["Standard: $80-$120", "Deep clean: $150-$250", "Move in/out: $200-$400"] },
  { icon: "⚡", category: "Electrical", typical: "$95-$150", per: "per hour", details: ["Outlet/switch: $75-$150", "Lighting: $100-$300", "Panel upgrade: $1,500-$3,000"] },
  { icon: "🔧", category: "Plumbing", typical: "$110-$180", per: "per hour", details: ["Drain cleaning: $100-$300", "Water heater: $800-$2,000", "Leak repair: $150-$500"] },
  { icon: "🌿", category: "Lawn & Outdoor", typical: "$50-$120", per: "per visit", details: ["Lawn mowing: $40-$80", "Tree trimming: $200-$1,000", "Landscaping: $50-$100/hr"] },
  { icon: "🎨", category: "Painting", typical: "$2-$5", per: "per sq ft", details: ["Interior: $2-$4/sq ft", "Exterior: $3-$5/sq ft", "Cabinets: $50-$100/door"] },
  { icon: "🚚", category: "Moving", typical: "$80-$150", per: "per hour", details: ["Local move: $80-$120/hr", "Long distance: $0.50-$1/mi", "Packing: $40-$60/hr"] },
];

export default function PricingPage() {
  const navigate = useNavigate();
  return (
    <div style={{ fontFamily: "'DM Sans', sans-serif", background: "#FAFAFA", color: "#0D1B3E", minHeight: "100vh" }}>
      <style>{`* { box-sizing: border-box; margin: 0; padding: 0; }`}</style>

      {/* Nav */}
      <nav style={{ background: "white", borderBottom: "1px solid #F3F4F6", padding: "16px 5%", display: "flex", alignItems: "center", justifyContent: "space-between" }}>
        <button onClick={() => navigate("/")} style={{ background: "transparent", border: "none", cursor: "pointer", fontFamily: "'Playfair Display', serif", fontSize: "1.5rem", fontWeight: 700, color: "#0D1B3E" }}>← Mouna</button>
        <button onClick={() => navigate("/login")} style={{ background: "#1A3CE8", color: "white", border: "none", borderRadius: "100px", padding: "10px 24px", fontWeight: 700, fontSize: "0.875rem", cursor: "pointer" }}>Get a Quote</button>
      </nav>

      {/* Hero */}
      <div style={{ background: "linear-gradient(135deg, #0D1B3E, #1A3CE8)", padding: "80px 5%", textAlign: "center", color: "white" }}>
        <div style={{ maxWidth: "780px", margin: "0 auto" }}>
          <div style={{ fontSize: "0.7rem", fontWeight: 700, color: "#F5A623", letterSpacing: "0.15em", textTransform: "uppercase", marginBottom: "20px" }}>TRANSPARENT PRICING</div>
          <h1 style={{ fontFamily: "'Playfair Display', serif", fontSize: "clamp(2.5rem, 5vw, 4rem)", fontWeight: 700, marginBottom: "20px", lineHeight: 1.1 }}>
            No hidden fees.<br/>
            <em style={{ color: "#F5A623" }}>Ever.</em>
          </h1>
          <p style={{ color: "rgba(255,255,255,0.75)", fontSize: "1.125rem", lineHeight: 1.7 }}>
            See typical Houston rates for popular services. Your pro will confirm an exact quote when they accept your booking.
          </p>
        </div>
      </div>

      {/* Three pillars */}
      <div style={{ padding: "60px 5%", background: "white", borderBottom: "1px solid #F3F4F6" }}>
        <div style={{ maxWidth: "1100px", margin: "0 auto", display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(260px, 1fr))", gap: "20px" }}>
         {[
            { icon: "🆓", title: "Free for Customers", desc: "No fees, no subscriptions. You only pay your service pro." },
            { icon: "💵", title: "Pros Set Their Rates", desc: "Every pro lists their pricing. Get a confirmed quote after booking, before the work begins." },
            { icon: "🏠", title: "Houston-Local Pros", desc: "Every pro on Mouna serves the Greater Houston area. No outsourcing, no call centers." },
          ].map(item => (
            <div key={item.title} style={{ textAlign: "center", padding: "24px" }}>
              <div style={{ fontSize: "2.5rem", marginBottom: "16px" }}>{item.icon}</div>
              <div style={{ fontWeight: 700, fontSize: "1.125rem", marginBottom: "8px" }}>{item.title}</div>
              <div style={{ color: "#6B7280", fontSize: "0.9375rem", lineHeight: 1.6 }}>{item.desc}</div>
            </div>
          ))}
        </div>
      </div>

      {/* Service pricing */}
      <div style={{ padding: "80px 5%", background: "#F9FAFB" }}>
        <div style={{ maxWidth: "1100px", margin: "0 auto" }}>
          <div style={{ textAlign: "center", marginBottom: "48px" }}>
            <div style={{ fontSize: "0.7rem", fontWeight: 700, color: "#1A3CE8", letterSpacing: "0.15em", textTransform: "uppercase", marginBottom: "16px" }}>SERVICE PRICING</div>
            <h2 style={{ fontFamily: "'Playfair Display', serif", fontSize: "clamp(2rem, 4vw, 3rem)", fontWeight: 700, marginBottom: "12px" }}>Typical Houston rates</h2>
            <p style={{ color: "#6B7280", fontSize: "1rem", maxWidth: "560px", margin: "0 auto" }}>
              Actual prices vary by job size, complexity, and pro experience.
            </p>
          </div>
          <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(300px, 1fr))", gap: "20px" }}>
            {SERVICE_PRICING.map(svc => (
              <div key={svc.category} style={{ background: "white", borderRadius: "24px", padding: "32px 28px", border: "1px solid #F3F4F6" }}>
                <div style={{ display: "flex", alignItems: "center", gap: "16px", marginBottom: "20px" }}>
                  <div style={{ width: "52px", height: "52px", borderRadius: "16px", background: "#EEF1FF", display: "flex", alignItems: "center", justifyContent: "center", fontSize: "1.625rem" }}>{svc.icon}</div>
                  <div>
                    <div style={{ fontWeight: 700, fontSize: "1.0625rem" }}>{svc.category}</div>
                    <div style={{ color: "#6B7280", fontSize: "0.8125rem" }}>{svc.per}</div>
                  </div>
                </div>
                <div style={{ fontFamily: "'Playfair Display', serif", fontSize: "2rem", fontWeight: 700, color: "#1A3CE8", marginBottom: "16px" }}>{svc.typical}</div>
                <div style={{ borderTop: "1px solid #F3F4F6", paddingTop: "16px" }}>
                  {svc.details.map(d => (
                    <div key={d} style={{ display: "flex", alignItems: "center", gap: "8px", marginBottom: "8px", color: "#4B5563", fontSize: "0.875rem" }}>
                      <span style={{ color: "#0E8C6A", fontWeight: 700 }}>•</span>
                      <span>{d}</span>
                    </div>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* How pricing works */}
      <div style={{ padding: "80px 5%", background: "white" }}>
        <div style={{ maxWidth: "780px", margin: "0 auto" }}>
          <div style={{ textAlign: "center", marginBottom: "48px" }}>
            <div style={{ fontSize: "0.7rem", fontWeight: 700, color: "#1A3CE8", letterSpacing: "0.15em", textTransform: "uppercase", marginBottom: "16px" }}>HOW PRICING WORKS</div>
            <h2 style={{ fontFamily: "'Playfair Display', serif", fontSize: "clamp(2rem, 4vw, 2.75rem)", fontWeight: 700 }}>Simple and fair</h2>
          </div>
          <div style={{ display: "flex", flexDirection: "column", gap: "20px" }}>
         {[
              { step: "1", title: "Browse Houston pros", desc: "Search by category or service. Each pro lists their rates upfront." },
              { step: "2", title: "Book the pro you want", desc: "Pick the pro that fits your job. Send them your request with details and photos." },
              { step: "3", title: "Pro confirms with a quote", desc: "Your pro reviews the job and confirms with an exact price before the work begins." },
              { step: "4", title: "Job done, pay direct", desc: "Pay your pro directly when the work is complete. Mouna takes nothing from you." },
            ].map(item => (
              <div key={item.step} style={{ display: "flex", gap: "20px", alignItems: "flex-start" }}>
                <div style={{ width: "44px", height: "44px", borderRadius: "12px", background: "#1A3CE8", color: "white", display: "flex", alignItems: "center", justifyContent: "center", fontWeight: 700, fontSize: "1rem", flexShrink: 0 }}>{item.step}</div>
                <div>
                  <div style={{ fontWeight: 700, fontSize: "1.0625rem", marginBottom: "4px" }}>{item.title}</div>
                  <div style={{ color: "#6B7280", fontSize: "0.9375rem", lineHeight: 1.6 }}>{item.desc}</div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* FAQ */}
      <div style={{ padding: "80px 5%", background: "#F9FAFB" }}>
        <div style={{ maxWidth: "780px", margin: "0 auto" }}>
          <div style={{ textAlign: "center", marginBottom: "48px" }}>
            <div style={{ fontSize: "0.7rem", fontWeight: 700, color: "#1A3CE8", letterSpacing: "0.15em", textTransform: "uppercase", marginBottom: "16px" }}>FAQ</div>
            <h2 style={{ fontFamily: "'Playfair Display', serif", fontSize: "clamp(2rem, 4vw, 2.75rem)", fontWeight: 700 }}>Common questions</h2>
          </div>
          <div style={{ display: "flex", flexDirection: "column", gap: "16px" }}>
           {[
              { q: "Is Mouna free for customers?", a: "Yes. Customers pay nothing to use Mouna. You only pay your service pro for the work they do." },
              { q: "How are prices set?", a: "Pros set their own rates based on their experience and the job. Your pro confirms an exact quote after you book, before the work begins." },
              { q: "Are there any hidden fees?", a: "No. The price your pro quotes is the price you pay. Mouna does not add any fees on top." },
              { q: "What if I'm not satisfied?", a: "Reach out to support@mounahub.com and we'll help connect you with your pro to resolve the issue." },
              { q: "When do I pay?", a: "After the job is complete. Most pros accept cash, check, or card directly. Mouna does not collect payment from you." },
              { q: "Can I get a refund?", a: "Refund and payment terms are between you and your pro, since Mouna doesn't process payment." },
            ].map(item => (
              <details key={item.q} style={{ background: "white", borderRadius: "16px", padding: "20px 24px", cursor: "pointer", border: "1px solid #F3F4F6" }}>
                <summary style={{ fontWeight: 700, fontSize: "1rem", color: "#0D1B3E", listStyle: "none", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                  {item.q}
                  <span style={{ color: "#9CA3AF", fontSize: "1.5rem" }}>+</span>
                </summary>
                <p style={{ color: "#6B7280", fontSize: "0.9375rem", lineHeight: 1.7, marginTop: "12px" }}>{item.a}</p>
              </details>
            ))}
          </div>
        </div>
      </div>

      {/* CTA */}
      <div style={{ padding: "80px 5%", background: "linear-gradient(135deg, #0E8C6A, #12B886)", textAlign: "center", color: "white" }}>
        <div style={{ maxWidth: "600px", margin: "0 auto" }}>
          <h2 style={{ fontFamily: "'Playfair Display', serif", fontSize: "clamp(2rem, 4vw, 2.75rem)", fontWeight: 700, marginBottom: "16px" }}>Get your free quote today</h2>
         <p style={{ color: "rgba(255,255,255,0.85)", fontSize: "1.0625rem", marginBottom: "32px", lineHeight: 1.7 }}>Browse Houston pros and book in minutes.</p>
          <button onClick={() => navigate("/login")} style={{ background: "white", color: "#0E8C6A", border: "none", borderRadius: "100px", padding: "16px 40px", fontWeight: 700, fontSize: "1rem", cursor: "pointer" }}>
            Get Free Quote →
          </button>
        </div>
      </div>

      <div style={{ background: "#080F20", padding: "32px 5%", textAlign: "center", color: "rgba(255,255,255,0.4)", fontSize: "0.75rem" }}>© 2026 Mouna. All rights reserved.</div>
    </div>
  );
}
